import MainTabs from "./components/widgets/MainTabs"
import { usePath } from "./libs/path/PathProvider";
import Loading from "./gui/Loading/Loading";
import usePortfolio from "./hooks/PortfolioProvider";
import Utils from "./libs/Utils"
import Button from "./gui/Button/Button";
import useAddHolding from "./components/addholding/AddHolding";
import { useEffect } from "react";
import useTransactionsDlg from "./components/transactions/TransactionsDlg";
import { useDividendDlg } from "./components/addholding/DividendDlg";
import { Price } from "./models/Price";
import PortUtils from "./portlibs/PortUtils";

import Home from "./pages/Home"
import SummaryPage from "./pages/SummaryPage";
import FixedPage from "./pages/FixedPage"
import DividendPage from "./pages/DividendPage";
import DivHistory from "./pages/DivHistory";
import CalendarPage from "./pages/CalendarPage";
import SectorPage from "./pages/SectorPage";
import TaxPage from "./pages/TaxPage";
import HistoryPage from "./pages/HistoryPage";
import ConfigPage from "./pages/ConfigPage";
import { useConfigDlg } from "./components/config/ConfigDlg";
import { useReinvestDlg } from "./components/addholding/ReinvestDlg";

function Error(props:{error:any}) {
  const onRetry = () => document.location.reload()
  return <div className="error grid center">
    <div className="content">
      <p className="error">{Utils.errorMsg(props.error).message}</p>
      <Button variant="contained" onClick={onRetry}>Retry</Button>
    </div>
  </div>
}

export default function App() {
  const {path,hash,setPath} = usePath()
  const {ready,error} = usePortfolio()
  const {addHolding} = useAddHolding()
  const {addDividend} = useDividendDlg()
  const {showHistory} = useTransactionsDlg()
  const {openConfig} = useConfigDlg()
  const {addReinvest} = useReinvestDlg()
  const {portfolio} = usePortfolio()

  var content:JSX.Element;
  switch(path){
  case "/home":
    content = <Home/>
    break;
  case "/summary":
    content = <SummaryPage/>
    break;
  case "/fixed":
    content = <FixedPage/>
    break;
  case "/dividends":
    content = <DividendPage/>
    break;
  case "/dhistory":
    content = <DivHistory/>
    break;
  case "/calendar":
    content = <CalendarPage/>
    break;
  case "/sector":
    content = <SectorPage/>
    break;
  case "/tax":
    content = <TaxPage/>
    break;
  case "/history":
    content = <HistoryPage/>
    break;
  case "/config":
    content = <ConfigPage/>
    break;
  default:
    setPath("/home")
    content = <></>
  }

  useEffect(() => {
    if (!ready) return

    const {holdingId,action,transactionId} = PortUtils.parseHash(hash)
    holdingId && action!="config" && showHistory(holdingId)

    const transaction = holdingId ? portfolio.holding(holdingId)?.transaction(transactionId) : null

    if (action) switch(action) {
    case "add":     addHolding({holdingId}); break;
    case "update":  addHolding({transaction}); break;
    case "dividend":addDividend({holdingId}); break;
    case "reinvest":addReinvest(holdingId); break;
    case "config":  holdingId && openConfig(holdingId); break;
    }
  }, [hash,ready])

  if (error) return <Error error={error}/>
  else if (!ready) return <Loading className="grid place-center"/>
  else return <>
    <MainTabs/>
    {content}
  </>
}
